<template>
  <div>
    <div>
      <vx-card>
        <div class="mt-5" v-if="dadosEncomenda">
          <h3 class="mb-6">Chamado {{ dadosEncomenda.idChamado }}</h3>

          <div class="text-right mb-3">
            <vs-button color="primary" type="gradient" class="mb-2 text-white forceWhite mr-3"
              @click="modalCobranca = true"><vs-icon icon-pack="feather" icon="icon-plus" class="mr-3"></vs-icon>
              <vs-icon icon-pack="feather" icon="icon-dollar-sign" class="mr-3"></vs-icon>
              Adicionar Cobrança Frete
            </vs-button>
          </div>
          <div>
            <vs-popup class="holamundo" :title="'Adicionar Cobrança Frete'" :active.sync="modalCobranca"
              @close="modalCobranca = false">
              <form role="form" @submit.stop.prevent autocomplete="off" data-vv-scope="form-1">
                <div class="vx-row mb-6">
                  <div class="vx-col w-full">
                    <span>Valor:</span>
                    <money class="w-full vs-inputx vs-input--input large" name="Valor" id="Valor" v-validate="{
                      required: true,
                      min_value: 0.01,
                      max_value: 150,
                    }" v-model="formAvulso.valor" v-bind="money"></money>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/1 w-full mb-2">
                    <vs-textarea label="Observação" v-model="formAvulso.observacao" name="Observação"
                      v-validate="{ required: true }" :state="validateState('Observação')"
                      :danger="validateClass('Observação')" />
                  </div>
                </div>
                <vs-alert v-if="$validator.errors.all().length > 0" color="danger" title="Atenção!!" active="true"
                  class="my-3" style="height: auto !important">
                  <ul>
                    <li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">
                      {{ error }}
                    </li>
                  </ul>
                </vs-alert>
                <vs-button color="success" @click="adicionarAvulso" type="gradient"
                  class="mt-1 mb-2">Adicionar</vs-button>
              </form>
            </vs-popup>
          </div>
          <div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/1 w-full mb-2">
                <vs-list>
                  <vs-list-item icon="apartment" title="Situação Atual">
                    <v-select :options="listaStatus" :reduce="(Tipo) => Tipo.value" label="text"
                      v-model="formTicket.idStatus"></v-select>
                  </vs-list-item>
                  <vs-list-item icon="date_range" title="Data do Chamado">
                    {{ formataData(dadosEncomenda.createdAt) }}
                  </vs-list-item>
                  <vs-list-item icon="money" title="Valor de Frete">
                    <money v-if="!dadosEncomenda.idUsuarioFrete" class="w-full vs-inputx vs-input--input large"
                      name="Valor" id="Valor" v-model="formTicket.valorFrete" v-bind="money"></money>
                    <vs-chip color="success" v-else>Frete grátis</vs-chip>
                  </vs-list-item>
                </vs-list>
                <div class="text-right">
                  <vs-button v-if="dadosEncomenda.idStatus != 4" color="success" @click="salvarEncomenda"
                    type="gradient" class="mt-1 mb-2">Salvar Dados</vs-button>
                </div>
              </div>

              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-card v-if="dadosEncomenda.itens.length > 0">
                  <div slot="header">
                    <h3>Itens</h3>
                  </div>
                  <div class="vx-row" v-for="file in dadosEncomenda.itens" :key="file.idItemEncomenda">
                    <div class="vx-col sm:w-1/5 w-full mb-2">
                      <img style="display: inline-flex" :src="file.imagem" width="50" height="50" />
                    </div>
                    <div class="vx-col sm:w-1/3 w-full mb-2">
                      <h4>{{ file.nomeItem }}</h4>
                      <p>Valor do Item: {{ file.valor | currency }}</p>
                      <p>Caixa: {{ file.nomeCaixa }}</p>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full mb-2">
                      <p>Altura: {{ file.altura }} cm</p>
                      <p>Largura: {{ file.largura }} cm</p>
                      <p>Comprimento: {{ file.comprimento }} cm</p>
                      <p>Peso: {{ file.pesoGramas }} gramas</p>
                    </div>
                    <div class="vx-col sm:w-1/1 w-full mb-2">
                      <p>Adicionado em: {{ formataData(file.createdAt) }}</p>
                    </div>
                    <div class="vx-col sm:w-1/1 w-full mb-2">
                      <hr />
                    </div>
                  </div>
                </vs-card>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-card>
                  <div slot="header">
                    <h3>Responsável</h3>
                  </div>
                  <vs-list>
                    <vs-list-item icon="person" title="Nome">
                      <v-select style="width: 200px" :options="usuarios" :reduce="(Tipo) => Tipo.idUsuario" label="nome"
                        v-model="formTicket.idUsuarioResponsavel"></v-select>
                    </vs-list-item>
                  </vs-list>
                </vs-card>
                <vs-card>
                  <div slot="header">
                    <h3>Criador</h3>
                  </div>
                  <vs-list>
                    <vs-list-item icon="person" title="Nome">
                      {{ dadosEncomenda.usuario }}
                      <a target="_blank" :href="returnLinkWhats2(
                        dadosEncomenda.usuario,
                        dadosEncomenda.celular
                      )
                        ">
                        <vs-button radius v-tooltip="'Whatsapp'" color="success" type="gradient" icon-pack="fa"
                          icon="fa-whatsapp" class="d-inline"></vs-button>
                      </a>
                    </vs-list-item>
                    <vs-list-item icon="phone" title="Telefone">
                      {{ dadosEncomenda.celular }}
                    </vs-list-item>
                    <vs-list-item icon="mail" title="Email">
                      {{ dadosEncomenda.email }}
                    </vs-list-item>
                    <vs-list-item icon="home" title="Endereço">
                      {{ dadosEncomenda.cep }}<br />
                      {{ dadosEncomenda.endereco }},
                      {{ dadosEncomenda.numero }} {{ dadosEncomenda.complemento
                      }}<br />
                      {{ dadosEncomenda.cidade }}, {{ dadosEncomenda.estado }}
                    </vs-list-item>
                  </vs-list>
                </vs-card>
              </div>
            </div>
            <vs-card v-if="dadosEncomenda.financeiro">
              <div slot="header">
                <h3 class="mb-6">Financeiro</h3>
              </div>
              <div v-if="dadosEncomenda.financeiro.length == 0">
                <vs-alert style="height: auto" active="true" color="danger">
                  Nenhum Registro Financeiro Encontrado
                </vs-alert>
              </div>

              <div v-else v-for="item in dadosEncomenda.financeiro" :key="item.id_boleto">
                <vs-collapse type="border" v-if="!item.deletedAt">
                  <vs-collapse-item>
                    <div slot="header">
                      {{ item.descricao }}

                      <vs-chip v-if="item.nomeStatus" class="mr-4" :color="getStatusBoletoColor(item.nomeStatus)">
                        {{ item.nomeStatus }}
                      </vs-chip>

                      <vs-chip v-if="validaVencido(item)" class="mr-4" color="danger">
                        Vencido
                      </vs-chip>
                    </div>
                    <vs-row>
                      <vs-col vs-type="flex" vs-justify="center" vs-w="12" vs-sm="12" vs-xs="12">
                        <table class="table table-bordered">
                          <tr v-if="item.idRegistroFinanceiro">
                            <th class="uppercase">ID</th>
                            <td>{{ item.idRegistroFinanceiro }}</td>
                          </tr>
                          <tr v-if="item.nossoNumero">
                            <th class="uppercase">Nosso Número</th>
                            <td>{{ item.nossoNumero }}</td>
                          </tr>
                          <tr>
                            <th class="uppercase">Data de Emissão</th>
                            <td>
                              {{ formataData(item.createdAt) }}
                            </td>
                          </tr>
                          <tr>
                            <th class="uppercase">Data de Vencimento</th>
                            <td>
                              {{ formataData(item.dataVencimento) }}
                            </td>
                          </tr>
                          <tr v-if="item.dataPagamento">
                            <th class="uppercase">Data de Pagamento</th>
                            <td>
                              {{ formataData(item.dataPagamento) }}
                            </td>
                          </tr>
                          <tr v-if="item.dataBaixaManual">
                            <th class="uppercase">Baixa Manual</th>
                            <td>
                              em {{ formataData(item.dataBaixaManual) }}, por
                              {{ item.baixadoPor }}
                            </td>
                          </tr>
                          <tr>
                            <th class="uppercase">Valor</th>
                            <td>
                              <span>{{
                                item.valor | currency
                              }}</span>
                            </td>
                          </tr>
                          <tr v-if="item.dataPagamento">
                            <th class="uppercase">Valor Pago</th>
                            <td>
                              <span>{{
                                item.valor | currency
                              }}</span>
                            </td>
                          </tr>
                          <tr v-if="item.linhaDigitavel">
                            <th class="uppercase">Linha Digitavel</th>
                            <td>{{ item.linhaDigitavel }}</td>
                          </tr>
                          <tr v-if="item.linhaDigitavel">
                            <th class="uppercase">Link Boleto</th>
                            <td>
                              <router-link target="_blank"
                                :to="`/Boleto/${item.idRegistroFinanceiro}?nn=${item.nossoNumero}`">Visualizar
                                Boleto</router-link>
                            </td>
                          </tr>

                          <tr v-if="item.pixImage">
                            <th class="uppercase">Pix Qr Imagem</th>
                            <td>
                              <VueQr :text="item.pixQrCode" />
                            </td>
                          </tr>
                          <tr v-if="item.pixQrCode">
                            <th class="uppercase">Pix Qr Code</th>
                            <td style="word-break: break-all">
                              {{ item.pixQrCode }}
                            </td>
                          </tr>
                          <tr v-if="
                            item.id_status == 3 &&
                            item.forma_pagamento != 'Cartão de Crédito'
                          ">
                            <th>Enviar Msg</th>
                            <td>
                              <a target="_blank" :href="returnLinkWhats(item)">
                                <vs-button v-tooltip="'Whatsapp'" radius color="success" type="gradient" icon-pack="fa"
                                  icon="fa-whatsapp" class="d-inline"></vs-button>
                              </a>
                            </td>
                          </tr>
                          <tr v-if="item.observacao">
                            <th class="uppercase">Observação</th>
                            <td style="word-break: break-all">
                              {{ item.observacao }}
                            </td>
                          </tr>
                          <tr v-if="item.motivoCancelamentoExclusao">
                            <th class="uppercase">Motivo Cancelamento</th>
                            <td style="word-break: break-all">
                              {{ item.motivoCancelamentoExclusao }}
                            </td>
                          </tr>
                        </table>
                      </vs-col>
                    </vs-row>
                  </vs-collapse-item>
                </vs-collapse>
              </div>
            </vs-card>
            <vs-card v-if="dadosEncomenda.respostas">
              <div slot="header">
                <h3 class="mb-6">
                  {{
                    dadosEncomenda.respostas.length > 0
                      ? dadosEncomenda.respostas.length == 1
                        ? dadosEncomenda.respostas.length + " Resposta"
                        : dadosEncomenda.respostas.length + " Respostas"
                      : "Sem Respostas"
                  }}
                </h3>
              </div>

              <div class="vx-row">
                <div class="vx-col sm:w-1/1 w-full mb-2">
                  <vs-list v-for="item in dadosEncomenda.respostas" :key="item.idResposta">
                    <vs-list-header icon-pack="feather" icon="icon-users"
                      :title="`${item.nome} em ${formataData(item.createdAt)}`"></vs-list-header>
                    <vs-list-item icon="reply" title="Resposta  " v-bind:subtitle="item.texto" style="overflow: auto">
                    </vs-list-item>
                  </vs-list>
                  <!-- <vs-list>
                  <vs-list-item v-for="item in dadosEncomenda.respostas" :key="item.idResposta"
                  icon="reply" v-bind:title="item.autor"
                  v-bind:subtitle="formataData(item.createdAt)"
                  style="overflow: auto">
                  {{item.resposta}}
                  </vs-list-item>
                </vs-list> -->
                  <!-- <p>{{ item.OuvidoriaResposta_Usuarios.nome }} respondeu em {{ formataData(item.createdAt) }} </p>
                <p>{{item.resposta}}</p> -->
                </div>
              </div>
            </vs-card>
            <form v-if="dadosEncomenda.nomeStatus != 'Finalizado'" role="form" @submit.stop.prevent autocomplete="off"
              data-vv-scope="form-2">
              <div class="vx-row">
                <div class="vx-col sm:w-1/1 w-full mb-2">
                  <vs-textarea label="Inserir Nova Resposta" v-model="form.texto" name="Resposta"
                    v-validate="{ required: true }" :state="validateState('Resposta')"
                    :danger="validateClass('Resposta')" />
                </div>
              </div>
              <vs-button color="success" v-if="dadosEncomenda.idStatus != 4" @click="responderChamado" type="gradient"
                class="mt-1 mb-2">Salvar Resposta</vs-button>
            </form>
          </div>
        </div>
      </vx-card>
      <div class="vx-row" v-if="dadosEncomenda">
        <div class="vx-col w-full text-right" v-if="dadosEncomenda.nomeStatus != 'Finalizado'">
          <vs-button v-if="dadosEncomenda.idStatus != 4" color="danger" @click="confirmFinaliza" type="gradient"
            class="mt-2 mb-2">Finalizar Chamado</vs-button>
        </div>
      </div>
      <!-- <div class="vx-row mt-3">
        <div v-if="precisaAlterarProduto==false" class="vx-col w-full text-right">
          <form role="form" @submit.stop.prevent="onSubmit">
            <BotaoSubmit variant="success" :edit="true" :aguarde="aguardeCadastro"></BotaoSubmit>
          </form>
        </div>
        <div v-else class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click="passo=3"
          >Buscar e Atualizar Produtos</vs-button>
        </div>
      </div> -->
    </div>
    <vs-popup class="holamundo" :title="'Detalhes Arquivo'" :active.sync="popupFile" @close="closeFile">
      <vs-list v-if="popupFile == true">
        <div class="carousel-example">
          <swiper :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
            <swiper-slide v-for="file in popupFiles" :key="file.idArquivo">
              <img class="responsive" :src="file.arquivo" alt="banner" />
            </swiper-slide>
          </swiper>
        </div>
      </vs-list>
    </vs-popup>

    <vs-popup class="holamundo" :title="'Finalizar Chamado'" :active.sync="popupFinaliza" @close="closeFinaliza">
      <vs-list>
        <vs-list-header title="Deseja Finalizar o Chamado?" color="gray"></vs-list-header>
        <vs-list-item>
          <vs-button @click.stop.prevent="closeFinaliza()" color="danger" type="border">Cancelar</vs-button>
          <vs-button style="margin-left: 10px" @click="finalizaChamado()" color="success"
            type="filled">Confirmar</vs-button>
        </vs-list-item>
      </vs-list>
    </vs-popup>
  </div>
</template>

<script>
import service from "./../../../services";
import locale from "./../../../locale";
import Datepicker from "vuejs-datepicker";
import { Money } from "v-money";
import moment from "moment";
import BotaoSubmit from "./../../../components/BotaoSubmit";
import jwt from "jsonwebtoken";
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import vSelect from "vue-select";
import VueQr from "vue-qr";
export default {
  components: {
    Datepicker,
    Money,
    BotaoSubmit,
    swiper,
    swiperSlide,
    "v-select": vSelect,
    VueQr,
  },
  data() {
    return {
      aguardeCadastro: false,
      dadosEncomenda: null,
      precisaAlterarProduto: false,
      regionais: [],
      consultores: [],
      status: [],
      grupos: [],
      listaCores: [],
      listaCombustiveis: [],
      fotos: [],
      form: {
        idEncomenda: this.$route.params.idEncomenda,
        texto: "",
      },
      passo: 0,
      decoded: null,
      popupFile: false,
      popupFiles: [],
      listaStatus: [],
      usuarios: [],
      popupFinaliza: false,
      formTicket: {
        idEncomenda: this.$route.params.idEncomenda,
        idUsuarioResponsavel: null,
        valorFrete: 0,
        idStatus: null,
      },
      file: new FormData(),
      files: [],
      paths: [],
      modalCobranca: false,
      modalEncomenda: false,
      idEncomenda: null,
      formAvulso: {
        idEncomenda: this.$route.params.idEncomenda,
        idUsuario: null,
        valor: 0,
        observacao: null,
        tipo: "Crédito",
      },
    };
  },
  methods: {
    formatarDescricaoItem(item) {
      let str =
        "Solicitação de Crédito Saldo em " +
        this.formataData(item.createdAt) +
        " no valor de R$ " +
        item.valor.toFixed(2);

      return str;
    },

    getStatusBoletoColor(data) {
      const warning = ["ABERTO", "BAIXADO COM PENDÊNCIA", "Em Aberto"];

      const success = ["BAIXADO", "Finalizado"];

      const danger = [
        undefined,
        "",
        "CANCELADO",
        "Cancelado",
        "Processado com Falha",
      ];

      const dark = ["EXCLUIDO", "Não Processado"];

      const primary = ["Em Processamento"];

      if (warning.includes(data)) return "warning";
      if (success.includes(data)) return "success";
      if (danger.includes(data)) return "danger";
      if (dark.includes(data)) return "dark";
      if (primary.includes(data)) return "primary";
    },
    validaVencido(item) {
      if (
        item.nomeStatus != "Finalizado" &&
        item.nomeStatus != "Cancelado" &&
        item.nomeStatus != "BAIXADO"
      ) {
        if (moment().diff(moment(item.dataVencimento), "days") > 0) return true;
      }
      return false;
    },
    returnLinkWhats2(nome, celular) {
      let texto = `Olá ${nome}, tudo bem? 😉 \nSomos do *Box da Sorte*, Recebemos seu pedido de encomenda e a partir de agora trataremos com o máximo agilidade, para que você receba sua encomenda no conforto do seu endereço.`;
      let textoEncode = encodeURI(texto);

      let link = "";
      link = `https://api.whatsapp.com/send?phone=5511934471420&text=${textoEncode}`;

      return link;
    },
    responderChamado() {
      this.$validator.validateAll("form-2").then((result) => {
        if (result) {
          this.$vs.loading();
          service
            .post("Encomenda", "InserirResposta", this.form)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: "top-center",
                title: "Obrigado",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });
              this.$emit("concluido");
              this.form.texto = "";
              this.form.pathFiles = [];
              this.files = [];
              this.buscaDados();
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },
    salvarEncomenda() {
      this.$vs.loading();
      service
        .post("Encomenda", "SalvarEncomenda", this.formTicket)
        .then((res) => {
          this.aguardeCadastro = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-center",
            title: "Obrigado",
            text: `Operação Realizada com sucesso`,
            color: "success",
          });
          this.$emit("concluido");
          this.buscaDados();
        })
        .catch((error) => {
          this.aguardeCadastro = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
        });
    },
    adicionarAvulso() {
      console.log("batue aqui");
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          this.$vs.loading();
          service
            .post("Usuario", "AdicionarCobrancaADM", this.formAvulso)
            .then((res) => {
              this.aguardeCadastro = false;
              this.modalCobranca = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: "top-center",
                title: "Obrigado",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });

              this.buscaDados();
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },
    buscaDados() {
      this.$vs.loading();
      var objSend = {};
      objSend.idChamado = this.$route.params.idChamado;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = this.idEmpresa;
      service
        .getAll(
          "Encomenda",
          {},
          "ListarDetalhe/" + this.$route.params.idEncomenda
        )
        .then((res) => {
          console.log(res.data);

          this.dadosEncomenda = res.data[0];

          if (this.dadosEncomenda.respostas)
            this.dadosEncomenda.respostas = JSON.parse(
              this.dadosEncomenda.respostas
            );
          if (this.dadosEncomenda.itens)
            this.dadosEncomenda.itens = JSON.parse(this.dadosEncomenda.itens);

          if (this.dadosEncomenda.usuarios)
            this.usuarios = JSON.parse(this.dadosEncomenda.usuarios);

          if (this.dadosEncomenda.financeiro)
            this.dadosEncomenda.financeiro = JSON.parse(
              this.dadosEncomenda.financeiro
            );

          this.formTicket.idStatus = this.dadosEncomenda.idStatus;
          this.formTicket.idUsuarioResponsavel =
            this.dadosEncomenda.idUsuarioResponsavel;
          this.formTicket.valorFrete = this.dadosEncomenda.valorFrete;

          this.formAvulso.idUsuario = this.dadosEncomenda.idUsuario;
          this.formAvulso.valor = this.formTicket.valorFrete;

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    formataData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm");
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaUsuario() {
      const token = localStorage.getItem("user-token");
      if (token) {
        this.decoded = jwt.decode(token);
        return this.decoded.email;
      } else {
        return null;
      }
    },

    openFile(files) {
      this.popupFiles = files;
      this.popupFile = true;
    },
    closeFile() {
      this.popupFile = false;
    },
    selecionaArquivo(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.file.set("file", event.target.files[0], event.target.files[0].name);
      this.files.push(files);
      this.paths.push(this.file);
      this.$vs.loading();
      var that = this;
      service
        .upload("Upload", "chamado/" + this.dadosEncomenda.idEmpresa, this.file)
        .then((response) => {
          that.form.pathFiles.push(response);
          that.$vs.loading.close();
        })
        .catch(function (error) {
          that.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: error,
            color: "danger",
          });
          that.$vs.loading.close();
        });
    },
    chooseFiles() {
      document.getElementById("fileUpload").click();
    },

    confirmFinaliza(chamado) {
      this.popupFinaliza = true;
    },
    closeFinaliza() {
      this.popupFinaliza = false;
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            value: element[campoPK],
            text: element[campoDescricao],
          });
        });
      });
    },
    finalizaChamado() {
      console.log("filtro", this.form);
      this.$vs.loading();
      service
        .post("Encomenda", "SalvarEncomenda", {
          idEncomenda: this.$route.params.idEncomenda,
          idStatus: 3,
        })
        .then((res) => {
          this.closeFinaliza();
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-center",
            title: "Obrigado",
            text: "Seu Chamado foi Finalizado!",
            color: "success",
          });
          this.form.resposta = "";
          this.form.pathFiles = [];
          this.buscaDados();
        });
    },
  },
  mounted() {
    this.buscaUsuario();
    this.$validator.localize("ptBr", locale);
    localStorage.removeItem("formFiltro");
    this.buscaDados();
    this.buscaDadosSelects(
      "domStatusEncomendas",
      "listaStatus",
      "nomeStatus",
      "idStatus"
    );
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}
</style>
<style scoped>
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");
</style>
